// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { AddressDef, AddressRef, AddressUpdateData, UserDoc, UserId, UserRef } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AddressActions {
  export class CreateAddress {
    static readonly type = '[Address] CreateAddress';
    constructor(
      public userRef: UserRef,
      public addressData: AddressUpdateData,
    ) {}
  }
  export class GetAllAddress {
    static readonly type = '[Address] GetAllAddress';
    readonly type = GetAllAddress.type;
  }

  export class InitAddress {
    static readonly type = '[Address] InitAddress';
    constructor(public id?: string) {}
  }

  export class CloseAddressConnection {
    static readonly type = '[Address] CloseAddressConnection';
    readonly type = CloseAddressConnection.type;
  }

  export class GetAddressById {
    static readonly type = '[Address] GetAddressById';
    readonly type = GetAddressById.type;
  }

  export class UpdateAddress {
    static readonly type = '[Address] UpdateAddress';
    constructor(
      public addressData: Partial<AddressUpdateData>,
      public id: AddressRef,
    ) {}
  }

  export class UpdateAddressResult {
    static readonly type = '[Address] UpdateAddressResult';
    constructor(public data: Array<TypesaurusCoreDoc<AddressDef> | null | undefined>) {}
  }

  export class DeleteAddress {
    static readonly type = '[Address] DeleteAddress';
    readonly type = DeleteAddress.type;
  }

  export class QueryAddress {
    static readonly type = '[Address] QueryAddress';

    constructor(
      public filter: {
        parent: UserId;
        query: AbstractQueryParams<AddressDef>[];
      },
    ) {}
  }

  export class SetSelectedUser {
    static readonly type = '[Address] SetSelectedUser';
    constructor(public selectedUser: UserDoc) {}
  }

  export class AddressError {
    static readonly type = '[Address] AddressError';
    constructor(public error: Error) {}
  }
}
